import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, formValueSelector} from 'redux-form';

import ErrorBlock from 'components/ErrorBlock';
import Label from 'components/Label';
import {
  TextField,
  DateField,
  MoneyField,
  CheckBoxField
} from 'components/Fields';
import FormField from 'components/FormField';

import {required, validDate} from 'utils/validators';
import {formatDateForApi} from 'utils/datetime';

import {
  MODALS,
  fetchBooking,
  addEmployment,
  fetchAffordability
} from 'ducks/bookings';
import {closeModal, storeDataInModal} from 'ducks/modals';

import './styles.css';

const onSubmit = (values, dispatch, props) => {
  const {unemployed, name, title, website, salary, startDate} = values;
  const {agreementUserId, affordabilityId, bookingId, locationRef} = props;

  const payload = {
    agreementUserId,
    unemployed,
    name,
    title,
    website,
    salary,
    startDate: formatDateForApi(startDate),
    affordabilityId,
    bookingId
  };

  const extraActions = [
    () => closeModal(MODALS.ADD_EMPLOYMENT),
    () => fetchBooking({locationRef, bookingId}),
    () =>
      fetchAffordability(payload, [
        affordability =>
          storeDataInModal({
            modalName: MODALS.AFFORDABILITY_DETAIL,
            data: {affordability}
          })
      ])
  ];

  dispatch(addEmployment(payload, extraActions));
};

class AddEmploymentForm extends React.Component<any> {
  onCheckBoxChange = () => {
    const {clearFields, form} = this.props;

    clearFields(form, false, false, 'name', 'title', 'website', 'salary');
  };

  requiredIfNotUnemployed = value => {
    return this.props.unemployedValue === false ? required(value) : undefined;
  };

  requiredIfUnemployed = value => {
    return this.props.unemployedValue === true ? required(value) : undefined;
  };

  render() {
    const {error, unemployedValue} = this.props;

    return (
      <form className="AddEmploymentForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Field
            name="unemployed"
            component={CheckBoxField}
            label="Unemployed"
            validate={[this.requiredIfUnemployed]}
            onChange={this.onCheckBoxChange}
          />
        </FormField>
        {!unemployedValue && (
          <div>
            <FormField>
              <Label>Employer</Label>
              <Field
                name="name"
                component={TextField}
                validate={[this.requiredIfNotUnemployed]}
              />
            </FormField>
            <FormField>
              <Label>Title/role</Label>
              <Field
                name="title"
                component={TextField}
                validate={[this.requiredIfNotUnemployed]}
              />
            </FormField>
            <FormField>
              <Label>Website</Label>
              <Field
                name="website"
                component={TextField}
                validate={[this.requiredIfNotUnemployed]}
              />
            </FormField>
            <FormField>
              <Label>Salary</Label>
              <Field
                name="salary"
                component={MoneyField}
                validate={[this.requiredIfNotUnemployed]}
              />
            </FormField>
          </div>
        )}
        <FormField>
          <Label>Start date</Label>
          <Field
            name="startDate"
            component={DateField}
            validate={[validDate]}
          />
        </FormField>
      </form>
    );
  }
}

const formSelector = formValueSelector('addEmployment');

const mapStateToProps = state => {
  return {
    initialValues: {
      unemployed: false
    },
    unemployedValue: formSelector(state, 'unemployed')
  };
};

const addEmploymentForm = reduxForm({
  form: 'addEmployment',
  onSubmit: onSubmit
})(AddEmploymentForm);

export default connect(mapStateToProps)(addEmploymentForm);
